import { createAction } from "redux-actions";
import {  GET_ADITIONAL_DEPOSIT, GET_ALL_DEPOSITS, GET_DEPOSIT_MOVEMENTS } from "../constants";
import { feathersCreateData } from "../services";

export const getDeposits = createAction(GET_ALL_DEPOSITS, (data) => feathersCreateData('core-server', 
    {
        service: 'DEPOSITS', 
        func: 'GET_ALL_DEPOSITS',
        data
    }
)() )

export const getDepositsAditional = createAction(GET_ADITIONAL_DEPOSIT, (data) => feathersCreateData('core-server', 
    {
        service: 'DEPOSITS', 
        func: 'GET_ADITIONAL_DEPOSIT',
        data
    }
)() )

export const getDepositsMovements = createAction(GET_DEPOSIT_MOVEMENTS, (startDate, endDate, SecuencialDeposito) => feathersCreateData('core-server', 
    {
        service: 'DEPOSITS', 
        func: 'RETURN MOVEMENTS DEPOSITS',
        data: {
            SecuencialDeposito : SecuencialDeposito,
            FechaInicio: startDate,
            FechaFin: endDate,
        }
    }
)() )
